import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Security } from '../proto/generated/security.ts'
import { TradingAccountStatus } from '../proto/generated/trading-bridge.ts';

export interface Holding {
  security: Security | undefined;
  quantity: number;
  averageBuyPrice: number;
  t1Quantity: number;
}

export interface HoldingsState {
  holdings: Holding[]
  loading: boolean
  error: string | null
  prevTradingAccountId: { id: string | null; status: TradingAccountStatus | null }
}

const initialState: HoldingsState = {
  holdings: [],
  loading: false,
  error: null,
  prevTradingAccountId: { id: null, status: null }
};

const holdingsSlice = createSlice({
  name: 'holdings',
  initialState,
  reducers: {
    setHoldings(state, action: PayloadAction<Holding[]>) {
      state.holdings = action.payload;
      state.loading = false;
      state.error = null;
    },
    setHoldingsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setHoldingsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setPrevHoldingsTradingAccountId(state, action: PayloadAction<{ id: string | null; status: TradingAccountStatus | null }>) {
      state.prevTradingAccountId = action.payload;
    }
  },
});

export const { setHoldings, setHoldingsLoading, setHoldingsError, setPrevHoldingsTradingAccountId } = holdingsSlice.actions;

export default holdingsSlice.reducer;